import React from 'react';
import { Text, StyleSheet } from '@react-pdf/renderer';

const s = StyleSheet.create({
  line1: {
    position: 'absolute',
    top: '33%',
    left: '-20%',
    width: '140%',
    textAlign: 'center',
    fontSize: 52,
    fontFamily: 'Helvetica-Bold',
    color: '#888888',
    opacity: 0.06,
    transform: 'rotate(-38deg)',
  },
  line2: {
    position: 'absolute',
    top: '53%',
    left: '-20%',
    width: '140%',
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'Helvetica',
    color: '#888888',
    opacity: 0.05,
    transform: 'rotate(-38deg)',
  },
});

export function PdfWatermark() {
  return (
    <>
      <Text style={s.line1} fixed>© MotorSportSuite</Text>
      <Text style={s.line2} fixed>Documento Riservato — Uso Personale</Text>
    </>
  );
}
